<template>
  <div style="margin: 10px">
    <v-card>
      <v-card-text>
        <v-layout>
          <v-flex>
            <v-text-field
                type="text"
                label="Mã vụ"
                :value="crop.code"
                disabled
            ></v-text-field>

          </v-flex>
          <v-flex>
            <v-text-field
                type="text"
                label="Số lượng giống"
                :value="numberOfSeed"
                disabled
            ></v-text-field>

          </v-flex>
        </v-layout>
        <table class="lstTable">
          <tr>
            <th width="100px">
              {{ $t("lang.envMeasure.date") }}
            </th>
            <th width="20px">Tuổi tôm</th>
            <th width="20px">Số lượng giống</th>
            <th width="20px">Thức ăn</th>
            <th width="20px">Khối lượng</th>
            <th width="20px">Tổng Kl thức ăn</th>
            <th width="20px">Size tôm (con/kg)</th>
            <th width="20px">Tổng khối lượng dự tính</th>
            <th v-for="item in lstIndex" width="20px">
              {{ $t(item.envName) }} ({{ item.unitType }})
            </th>
            <th width="20px">G</th>
            <th width="20px">Tỉ lệ tôm sống (%)</th>
            <th width="20px">Hệ số thức ăn</th>
            <th width="50px">
              {{ $t("lang.envMeasure.note") }}
            </th>
          </tr>
          <template v-for="item in lstItem">
            <template
                v-if="checkDate(item.date) && item.material != undefined && item.material != null && item.material.length > 0"
            >
              <tr v-for="(material, index) in item.material">
                <td v-if="index==0" :rowspan="item.material.length">{{ item.measureDate | formatDate }}
                </td>
                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  {{ shrimpAgeByDate(crop, item) }}
                </td>
                <td v-if="index==0" :rowspan="item.material.length">
                  {{item.numberOfSeed}}
                </td>
                <td>
                  {{ material.materialName }}
                </td>
                <td>

                  {{ material.total_export }}
                </td>
                <td v-if="index==0" :rowspan="item.material.length">
                  {{item.totalFood|currency}}
<!--                  tong kl thuc an-->
                </td>
                <td v-if="index==0" :rowspan="item.material.length">
                  <div style="text-align: right"
                      v-if="item.pmIdx['shrimpSize'] != undefined && item.pmIdx['shrimpSize'] != null && item.pmIdx['shrimpSize'] != ''">
                    {{ item.pmIdx["shrimpSize"] }}
                  </div>
                  <div style="text-align: right" v-else>
                    {{ item.amIdx["shrimpSize"] }}
                  </div>
                </td>

                <td style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  {{ getQuantity(item)|currency }}
                </td>

                <td v-for="idx in lstIndex" style="text-align: right" v-if="index==0" :rowspan="item.material.length">
                  <div
                      v-if="item.pmIdx[idx.envId] != undefined && item.pmIdx[idx.envId] != null && item.pmIdx[idx.envId] != ''">
                    {{ item.pmIdx[idx.envId] }}
                  </div>
                  <div v-else>
                    {{ item.amIdx[idx.envId] }}
                  </div>
                </td>
                <td v-if="index==0" :rowspan="item.material.length">
                  <div v-if="item.pmIdx.g != undefined && item.pmIdx.g != null && item.pmIdx.g != ''">
                    {{ item.pmIdx.g }}
                  </div>
                  <div v-else>
                    {{ item.amIdx.g }}
                  </div>
                </td>
                <td v-if="index==0" :rowspan="item.material.length">
                  <div style="text-align: right"
                      v-if="item.pmIdx['livePercent'] != undefined && item.pmIdx['livePercent'] != null && item.pmIdx['livePercent'] != ''">
                    {{ item.pmIdx["livePercent"] }}
                  </div>
                  <div style="text-align: right" v-else>
                    {{ item.amIdx["livePercent"] }}
                  </div>
                </td>
                <td v-if="index==0" :rowspan="item.material.length" style="text-align: right">{{getHesothucan(item)}}</td>
                <td v-if="index==0" :rowspan="item.material.length">{{ item.notes }}</td>
              </tr>
            </template>
            <template v-else-if="checkDate(item.date)">
              <tr>
                <td>{{
                    item.measureDate |
                        formatDate
                  }}
                </td>
                <td style="text-align: right">
                  {{ shrimpAgeByDate(crop, item) }}
                </td>
                <td>
                  {{item.numberOfSeed}}
                </td>
                <td>

                </td>
                <td></td>
                <td>
                  {{item.totalFood |currency}}
                  <!--                  tong kl thuc an-->
                </td>
                <td style="text-align: right"
                    v-if="item.pmIdx['shrimpSize'] != undefined && item.pmIdx['shrimpSize'] != null && item.pmIdx['shrimpSize'] != ''">
                  {{ item.pmIdx["shrimpSize"] }}
                </td>
                <td style="text-align: right" v-else>
                  {{ item.amIdx["shrimpSize"] }}
                </td>
                <td style="text-align: right">
                  {{ getQuantity(item)|currency }}
                </td>

                <td v-for="idx in lstIndex" style="text-align: right">
                  <div
                      v-if="item.pmIdx[idx.envId] != undefined && item.pmIdx[idx.envId] != null && item.pmIdx[idx.envId] != ''">
                    {{ item.pmIdx[idx.envId] }}
                  </div>
                  <div v-else>
                    {{ item.amIdx[idx.envId] }}
                  </div>
                </td>
                <td>
                  <div v-if="item.pmIdx.g != undefined && item.pmIdx.g != null && item.pmIdx.g != ''">
                    {{ item.pmIdx.g }}
                  </div>
                  <div v-else>
                    {{ item.amIdx.g }}
                  </div>
                </td>
                <td style="text-align: right"
                    v-if="item.pmIdx['livePercent'] != undefined && item.pmIdx['livePercent'] != null && item.pmIdx['livePercent'] != ''">
                  {{ item.pmIdx["livePercent"] }}
                </td>
                <td style="text-align: right" v-else>
                  {{ item.amIdx["livePercent"] }}
                </td>
                <td style="text-align: right">{{getHesothucan(item)}}</td>
                <td>{{ item.notes }}</td>
              </tr>
            </template>
          </template>

        </table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import {message} from "../../shared/message";
import moment from "moment";

export default {
  name: "pond-report-item",
  components: {},
  props: {
    crop: {
      type: Object,
      default: () => {
        return null;
      },
    },
    search: {
      type: Object,
      default: () => {
        return null;
      },
    },

  },

  watch: {
    search: {
      handler(value) {
        this.onSearch();
      },
      deep: true
    }
  },

  data: () => {
    return {
      lstIndex: [],
      lstPond: [],
      seedNumber: [],
      lstItem: [],
      g: null,
      numberOfSeed: 0,
      totalRows: 0,
      pagination: {
        rowsPerPage: 10,
        page: 1,
        totalItems: 0
      },
    };
  },

  created() {
    this.getEnvIndex();
    this.getSeedNumber();
    this.onSearch();
  },

  methods: {
    shrimpAgeByDate(crop, item) {
      let calculateDate = item.measureDate;
      let shrimpAge = 0;
      let dropDate = '';
      if (parseInt(crop.pondParent) > 0 && crop.dropDateParent != '' && crop.dropDateParent != null) {
        dropDate = moment(String(crop.dropDateParent));
      } else if (crop.dropDate != '' && crop.dropDate != null) {
        dropDate = moment(String(crop.dropDate));
      }
      //console.log(dropDate);
      if (dropDate != '') {
        let calculateDateMM = moment(calculateDate);
        let endDate = moment(calculateDate);
        if (crop.endDate) {
          endDate = moment(String(crop.endDate));
          if (endDate > calculateDateMM) endDate = calculateDateMM;
        }
        if (endDate > dropDate) {
          let dates = endDate.diff(dropDate, "days");
          if (dates >= 0) {
            shrimpAge = dates;
          }
        }
      }
      item.shrimpAge = shrimpAge;
      return shrimpAge;

    },

    getG() {
      if (this.search.areaId == undefined || this.search.areaId == null) {
        message.error("Chưa chọn khu");
        return;
      }
      axios.post(
          process.env.VUE_APP_API_URL + "/gindex/search", this.search
      ).then(
          (data) => {
            if (data.items && data.items.length > 0) {
              this.g = data.items[0];
              //console.log(this.g);
              if (this.g.g1 != undefined && this.g.g1 != null) {
                this.g.g1Index = JSON.parse(this.g.g1);
              } else {
                this.g.g1Index = {};
              }

              if (this.g.g2 != undefined && this.g.g2 != null) {
                this.g.g2Index = JSON.parse(this.g.g2);
              } else {
                this.g.g2Index = {};
              }
              //
              //
              //
              for (let i = 0; i < this.lstIndex.length; i++) {
                if (this.g.g1Index[this.lstIndex[i].envId] == undefined || this.g.g1Index[this.lstIndex[i].envId] == null) {
                  this.g.g1Index[this.lstIndex[i].envId] = {};
                }
                if (this.g.g2Index[this.lstIndex[i].envId] == undefined || this.g.g2Index[this.lstIndex[i].envId] == null) {
                  this.g.g2Index[this.lstIndex[i].envId] = {};
                }
              }
            }
          }
      );
    },

    getQuantity(item) {
      let quantity = item.numberOfSeed;
      let livePercent = item.pmIdx["livePercent"];
      if (livePercent == undefined || livePercent == null) {
        livePercent = item.amIdx["livePercent"];
      }
      let shrimpSize = item.pmIdx["shrimpSize"];
      if (shrimpSize == undefined || shrimpSize == null) {
        shrimpSize = item.amIdx["shrimpSize"];
      }

      if(livePercent == undefined){
        item.quantity = '';
        quantity = '';
      } else{
        quantity = (item.numberOfSeed * livePercent) / (shrimpSize * 100);
        item.quantity = quantity;
      }
      
      return quantity;
    },

    getHesothucan(item) {
      let tongkhoiluongdutinh = this.getQuantity(item);
      let hesothucan = 0;
      if(tongkhoiluongdutinh == undefined || tongkhoiluongdutinh == ''){
        item.hesothucan = 0;
        hesothucan = 0;
      } else{
        hesothucan = item.totalFood / tongkhoiluongdutinh;
        item.hesothucan = hesothucan;
      }

      let roundedString = '-';
      if (hesothucan != null && hesothucan > 0) {
        roundedString = hesothucan.toFixed(4);
        roundedString = roundedString.replace('.', ',');
      } 
      
      return roundedString;
    },

    getEnvIndex() {
      axios.post(
          process.env.VUE_APP_API_URL + "/envIndex/search?pageSize=-1&page=0", {}
      ).then(
          (data) => {
            this.lstIndex = data.items;
          }
      );
    },

    getSeedNumber() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/listByType?type=SEEDNUMBER"
      )
          .then(
              (data) => {
                //console.log(data);
                if (data.length > 0) {
                  this.seedNumber = data;
                  for (let i = 0; i < this.seedNumber.length; i++) {
                    if (this.seedNumber[i].categoryId == this.crop.seedNumber) {
                      this.numberOfSeed = parseInt(this.seedNumber[i].categoryCode);
                      break;
                    }
                  }
                }
              }
          );
    },

    onSearch() {

      if (this.search.areaId == undefined || this.search.areaId == null) {
        return;
      }

      let searchObject = Object.assign({}, this.search);
      searchObject.cropId = this.crop.cropId;
      searchObject.pondId = this.crop.pondId;
      axios.post(
          process.env.VUE_APP_API_URL + "/envMeasure/searchAllDataToNow?pageSize=-1&page=-1&isReport=1", searchObject
      ).then(
          (data) => {
            if (data.items) {
              this.lstItem = data.items;
              this.totalRows = data.count;
              for (let i = 0; i < this.lstItem.length; i++) {
                if (this.lstItem[i].am != undefined && this.lstItem[i].am != null) {
                  this.lstItem[i].amIdx = JSON.parse(this.lstItem[i].am);
                } else {
                  this.lstItem[i].amIdx = {};
                }

                if (this.lstItem[i].pm != undefined && this.lstItem[i].pm != null) {
                  this.lstItem[i].pmIdx = JSON.parse(this.lstItem[i].pm);
                } else {
                  this.lstItem[i].pmIdx = {};
                }
                this.lstItem[i].date = new Date(this.lstItem[i].measureDate).setHours(0, 0, 0);
              }

              this.getExportData();
              
              this.$emit("update", {
                crop: this.crop,
                data: this.lstItem
              });
              this.$forceUpdate();

            }
          }
      );
    },

    updateDateWhenNull(){
      if(this.lstItem.length == 0){
        return
      }
      let lastObjectNotNull = {};
      let pmIdx={};
      let amIdx={};
      // console.log(this.lstItem);
      for (let j = this.lstItem.length - 1 ; j > -1 ; j--) {
        //set vao last object
        // console.log("=======updateDateWhenNull=========");
        // console.log(this.lstItem[j].totalFood);
        if(lastObjectNotNull.totalFood != undefined && (this.lstItem[j].totalFood == null || this.lstItem[j].totalFood == undefined)){
          let foodQuantity = 0;
          if (this.lstItem[j].material != undefined && this.lstItem[j].material.length > 0) {
            foodQuantity = this.lstItem[j].material.reduce((n, {total_export}) => n + total_export, 0);
          }
          this.lstItem[j].totalFood = lastObjectNotNull.totalFood + foodQuantity;
        }
        if(this.lstItem[j].totalFood != undefined ){
          lastObjectNotNull.totalFood = this.lstItem[j].totalFood
        }
        // console.log(this.lstItem[j].totalFood);

        if(this.lstItem[j].numberOfSeed != undefined ){
          lastObjectNotNull.numberOfSeed=this.lstItem[j].numberOfSeed
        }
        if(this.lstItem[j].numberOfSeed == undefined  && lastObjectNotNull.numberOfSeed != undefined){
          this.lstItem[j].numberOfSeed = lastObjectNotNull.numberOfSeed;
        }

        if(this.lstItem[j].pmIdx != undefined && this.lstItem[j].pmIdx['shrimpSize'] != undefined ){
          pmIdx = this.lstItem[j].pmIdx;
        }
        if(this.lstItem[j].pmIdx != undefined && pmIdx != undefined){
          this.lstItem[j].pmIdx = pmIdx;
        }

        if(this.lstItem[j].amIdx != undefined && this.lstItem[j].amIdx['shrimpSize'] != undefined ){
          amIdx = this.lstItem[j].amIdx;
        }
        if(this.lstItem[j].amIdx != undefined && amIdx != undefined){
          this.lstItem[j].amIdx = amIdx;
        }
      }

      // const self = this;
      // this.lstItem = this.lstItem.filter((v, k) => {
      //   return moment(v.date) >= moment(self.search.fromDate);
      // });
    },

    updateLstExportOld() {
      let sum = 0;
      for (let i = 0; i < this.lstExport.length; i++) {
        this.lstExport[i].data = JSON.parse(this.lstExport[i].requestData);
        for (let j = this.lstExport[i].data.length - 1; j >= 0; j--) {
          if (this.lstExport[i].data[j].typeId != '421') {
            this.lstExport[i].data.splice(j, 1);
          }
        }

        let exportDate = new Date(this.lstExport[i].exportDate).setHours(0, 0, 0);
        // console.log("exportDate", exportDate);
        let sum = 0;
        //console.log("this.lstItem[j].material7777777", JSON.stringify(this.lstItem));
        for (let j = 0; j < this.lstItem.length; j++) {
          // console.log("this.lstItem[j].date", this.lstItem[j].date);
          if (this.lstItem[j].date == exportDate) {
            this.lstItem[j].material = this.lstExport[i].data;
            this.lstItem[j].exportedSum = this.lstExport[i].exportedSum;
            //linhdx tinh tong thuc an
            // try{
            //   for (let k = 0; k < this.lstItem[j].material.length; k++) {
            //       let material = this.lstItem[j].material[k]
            //       console.log("material.total_export", material.total_export)
            //       sum = sum + parseInt(material.total_export)
            //       console.log("sum 1", sum)
            //   }
            // } catch (e){
            // }
            // this.lstItem[j].sum = sum;
            //break;
          }

        }
      }
    },

    lstExportRequestData() {
      for (let i = 0; i < this.lstExport.length; i++) {
        this.lstExport[i].data = JSON.parse(this.lstExport[i].requestData);
        
        for (let j = this.lstExport[i].data.length - 1; j >= 0; j--) {
          if (this.lstExport[i].data[j].typeId != '421') {
            this.lstExport[i].data.splice(j, 1);
          }

          if (i+1 == this.lstExport.length && j == 0) {
            this.lstExportMaterial();
          }
        }
      }
    },

    lstExportMaterial() {
      for (let i = 0; i < this.lstExport.length; i++) {
        let exportDate = new Date(this.lstExport[i].exportDate).setHours(0, 0, 0);
        let sum = 0;
        for (let j = 0; j < this.lstItem.length; j++) {
          if (this.lstItem[j].date == exportDate) {
            this.lstItem[j].material = this.lstExport[i].data;
            this.lstItem[j].exportedSum = this.lstExport[i].exportedSum;
          }

          if (i+1 == this.lstExport.length && j+1 == this.lstItem.length) {
            this.updateDateWhenNull();
          }
        }
      }
    },

    getExportData() {
      let report = {
        areaId: this.search.areaId,
        cropId: this.crop.cropId,
        fromDate: this.search.fromDate,
        toDate: this.search.toDate,
        assetsNameId: this.search.assetsNameId,
      }
      axios.post(process.env.VUE_APP_API_URL + "/exportRequest/materialSearchReport?page=-1&pageSize=-1&sortField=exportDate&isReport=1", report).then(
          data => {
            this.lstExport = data.items;            
            this.lstExportRequestData();
            // console.log("this.lstItem", this.lstItem);
            this.$forceUpdate();
            this.$emit("update", {
              crop: this.crop,
              data: this.lstItem
            });
          }
      )
    },

    checkDate(date) {
      return moment(date) >= moment(this.search.fromDate);
    },

    onPaging: function (page) {
      this.pagination = page;
      this.onSearch();
    },
  },

  destroyed() {
  },
};
</script>

<style>
.indicator {
  margin: 5px 5px 5px 0px;
  padding: 5px;
  display: inline-block;
  border: 1px solid gray;
  width: fit-content;
}

.G2 {
  background-color: gold;
}

.G3 {
  background-color: crimson;
}
</style>